export const openChatBot = (callback?: () => void) => {
	const chatbotElement = document.querySelector('#chatbotButton')
	if (chatbotElement instanceof HTMLElement) {
		callback && callback()
		chatbotElement?.click()
	}
}